(function () {
  "use strict";

  /** @type {string[]} */
  var UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  var MODAL_STEP_UTM_CONTENT_VALUES = {
    cadastro: true,
    informacoes: true,
    dados_pessoais: true,
    pagamento: true
  };
  /** @type {string[]} */
  var EXTRA_KEYS = ["first_landing_page", "last_landing_page", "referrer"];
  // Click IDs commonly present on paid traffic when UTMs are missing.
  // We use these to infer "last-touch" attribution.
  var CLICK_ID_HINTS = [
    { param: "gclid", utm_source: "google", utm_medium: "cpc" },
    { param: "gbraid", utm_source: "google", utm_medium: "cpc" },
    { param: "wbraid", utm_source: "google", utm_medium: "cpc" },
    { param: "fbclid", utm_source: "facebook", utm_medium: "paid_social" },
    { param: "ttclid", utm_source: "tiktok", utm_medium: "paid_social" },
    { param: "twclid", utm_source: "twitter", utm_medium: "paid_social" },
    { param: "msclkid", utm_source: "bing", utm_medium: "cpc" }
  ];
  var STORAGE_KEY_LAST_SIGNATURE = "__utm_cart_signature__";
  var SESSION_KEY_STARTED = "__utm_session_started__";
  var SESSION_KEY_DISABLE_UTM_PERSISTENCE = "__utm_disable_url_persistence__";
  var SESSION_UTM_KEY_PREFIX = "__session_";
  var COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90; // 90 days
  var DEBOUNCE_MS = 250;
  var UTM_URL_PERSISTENCE_ENABLED = false;

  var canUseLocalStorage = testLocalStorage();
  var canUseSessionStorage = testSessionStorage();
  /** @type {ReturnType<typeof setTimeout> | null} */
  var syncTimer = null;
  var queuedSignature = "";
  var shouldRetryUTMDataLayerOnLoad = false;
  var utmPersistenceDisabledForSession = false;
  var didResetLastTouchForDirectEntry = false;

  function noop() {}

  /** @param {string} value */
  function isModalStepUtmContent(value) {
    var normalized = String(value || "").trim().toLowerCase();
    return !!MODAL_STEP_UTM_CONTENT_VALUES[normalized];
  }

  /** @param {string} key @param {string} value */
  function shouldPersistUtmParam(key, value) {
    return !(key === "utm_content" && isModalStepUtmContent(value));
  }

  function testLocalStorage() {
    try {
      var key = "__utm_storage_probe__";
      window.localStorage.setItem(key, "1");
      window.localStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  }

  function testSessionStorage() {
    try {
      var key = "__utm_session_storage_probe__";
      window.sessionStorage.setItem(key, "1");
      window.sessionStorage.removeItem(key);
      return true;
    } catch (error) {
      return false;
    }
  }

  /** @param {string} name */
  function getCookie(name) {
    try {
      var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      var match = document.cookie.match(new RegExp("(^|;\\s*)" + escaped + "=([^;]*)"));
      return match && match[2] ? decodeURIComponent(match[2]) : null;
    } catch (error) {
      return null;
    }
  }

  /** @param {string} name @param {string} value */
  function setCookie(name, value) {
    try {
      document.cookie =
        encodeURIComponent(name) +
        "=" +
        encodeURIComponent(value) +
        "; path=/; max-age=" +
        COOKIE_MAX_AGE_SECONDS +
        "; samesite=lax";
    } catch (error) {
      noop();
    }
  }

  /** @param {string} name */
  function deleteCookie(name) {
    try {
      document.cookie = encodeURIComponent(name) + "=; path=/; max-age=0; samesite=lax";
    } catch (error) {
      noop();
    }
  }

  /** @param {string} key */
  function getStoredValue(key) {
    if (canUseLocalStorage) {
      try {
        var localValue = window.localStorage.getItem(key);
        if (localValue !== null) return localValue;
      } catch (error) {
        canUseLocalStorage = false;
      }
    }
    return getCookie(key);
  }

  /** @param {string} key @param {string} value */
  function setStoredValue(key, value) {
    if (!value) return;

    if (canUseLocalStorage) {
      try {
        window.localStorage.setItem(key, value);
        return;
      } catch (error) {
        canUseLocalStorage = false;
      }
    }

    setCookie(key, value);
  }

  /** @param {string} key */
  function removeStoredValue(key) {
    if (canUseLocalStorage) {
      try {
        window.localStorage.removeItem(key);
      } catch (error) {
        canUseLocalStorage = false;
      }
    }

    deleteCookie(key);
  }

  /** @param {string} key */
  function getSessionValue(key) {
    if (!canUseSessionStorage) return null;

    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      canUseSessionStorage = false;
      return null;
    }
  }

  /** @param {string} key @param {string} value */
  function setSessionValue(key, value) {
    if (!canUseSessionStorage) return;

    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      canUseSessionStorage = false;
    }
  }

  /** @param {string} key */
  function removeSessionValue(key) {
    if (!canUseSessionStorage) return;

    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      canUseSessionStorage = false;
    }
  }

  function clearSessionUtmValues() {
    for (var i = 0; i < UTM_PARAMS.length; i++) {
      var utmKey = UTM_PARAMS[i] || "";
      if (!utmKey) continue;
      removeSessionValue(SESSION_UTM_KEY_PREFIX + utmKey);
    }
  }

  /** @param {Record<string, string>} values */
  function replaceSessionUtmValues(values) {
    clearSessionUtmValues();

    for (var i = 0; i < UTM_PARAMS.length; i++) {
      var utmKey = UTM_PARAMS[i] || "";
      var value = utmKey ? String(values[utmKey] || "").trim() : "";
      if (!value) continue;
      setSessionValue(SESSION_UTM_KEY_PREFIX + utmKey, value);
    }
  }

  function getCurrentPathWithQuery() {
    try {
      return window.location.pathname + window.location.search;
    } catch (error) {
      return "";
    }
  }

  function currentUrlHasTrackingSignal() {
    try {
      var params = new URLSearchParams(window.location.search);
      var i;

      for (i = 0; i < UTM_PARAMS.length; i++) {
        var utmKey = UTM_PARAMS[i] || "";
        var utmValue = utmKey ? (params.get(utmKey) || "").trim() : "";
        if (utmKey && utmValue && shouldPersistUtmParam(utmKey, utmValue)) return true;
      }

      for (i = 0; i < CLICK_ID_HINTS.length; i++) {
        var hint = CLICK_ID_HINTS[i];
        if (hint && hint.param && (params.get(hint.param) || "").trim()) return true;
      }

      return false;
    } catch (error) {
      return false;
    }
  }

  function isFirstPageViewInSession() {
    if (!canUseSessionStorage) return true;
    return getSessionValue(SESSION_KEY_STARTED) !== "1";
  }

  function markSessionStarted() {
    setSessionValue(SESSION_KEY_STARTED, "1");
  }

  function isDirectEntryWithoutTracking() {
    try {
      if (currentUrlHasTrackingSignal()) return false;
      if ((document.referrer || "").trim()) return false;

      if (window.performance && typeof window.performance.getEntriesByType === "function") {
        var entries = window.performance.getEntriesByType("navigation");
        var navigation = entries && entries[0];
        var type = navigation && /** @type {{ type?: string }} */ (navigation).type;
        if (type && type !== "navigate" && type !== "reload") return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  }

  function clearLastTouchUtmValues() {
    didResetLastTouchForDirectEntry = true;
    queuedSignature = "";
    removeStoredValue(STORAGE_KEY_LAST_SIGNATURE);

    for (var i = 0; i < UTM_PARAMS.length; i++) {
      var utmKey = UTM_PARAMS[i] || "";
      if (!utmKey) continue;
      removeStoredValue("last_" + utmKey);
    }
  }

  function prepareSessionAttribution() {
    try {
      if (currentUrlHasTrackingSignal()) {
        utmPersistenceDisabledForSession = false;
        removeSessionValue(SESSION_KEY_DISABLE_UTM_PERSISTENCE);
        markSessionStarted();
        return;
      }

      utmPersistenceDisabledForSession = getSessionValue(SESSION_KEY_DISABLE_UTM_PERSISTENCE) === "1";
      var isDirectEntry = isDirectEntryWithoutTracking();

      if (isDirectEntry) {
        clearSessionUtmValues();
      }

      if (isFirstPageViewInSession() && isDirectEntry) {
        clearLastTouchUtmValues();
        utmPersistenceDisabledForSession = true;
        setSessionValue(SESSION_KEY_DISABLE_UTM_PERSISTENCE, "1");
      }

      markSessionStarted();
    } catch (error) {
      noop();
    }
  }

  function isUtmUrlPersistenceAllowed() {
    return UTM_URL_PERSISTENCE_ENABLED && !utmPersistenceDisabledForSession;
  }

  function captureTrackingData() {
    try {
      var params = new URLSearchParams(window.location.search);
      var hasAnyExplicitUtm = false;
      var sessionUtmValues = {};

      for (var i = 0; i < UTM_PARAMS.length; i++) {
        /** @type {string} */
        var utmKey = UTM_PARAMS[i] || "";
        if (!utmKey) continue;
        var value = (params.get(utmKey) || "").trim();
        if (!value) continue;
        if (!shouldPersistUtmParam(utmKey, value)) continue;
        hasAnyExplicitUtm = true;
        sessionUtmValues[utmKey] = value;

        var firstKey = "first_" + utmKey;
        var lastKey = "last_" + utmKey;

        if (!getStoredValue(firstKey)) {
          setStoredValue(firstKey, value);
        }
        setStoredValue(lastKey, value);
      }

      if (hasAnyExplicitUtm) {
        replaceSessionUtmValues(sessionUtmValues);
      }

      // If the URL didn't bring explicit UTMs but contains click IDs, infer last-touch.
      if (!hasAnyExplicitUtm) {
        for (var j = 0; j < CLICK_ID_HINTS.length; j++) {
          var hint = CLICK_ID_HINTS[j];
          if (!hint || !hint.param) continue;
          var clickId = (params.get(hint.param) || "").trim();
          if (!clickId) continue;

          if (hint.utm_source) setStoredValue("last_utm_source", hint.utm_source);
          if (hint.utm_medium) setStoredValue("last_utm_medium", hint.utm_medium);
          replaceSessionUtmValues({
            utm_source: hint.utm_source || "",
            utm_medium: hint.utm_medium || ""
          });
          break;
        }
      }

      var landingPage = getCurrentPathWithQuery();
      if (landingPage) {
        if (!getStoredValue("first_landing_page")) {
          setStoredValue("first_landing_page", landingPage);
        }
        setStoredValue("last_landing_page", landingPage);
      }

      if (!getStoredValue("referrer") && document.referrer) {
        setStoredValue("referrer", document.referrer);
      }
    } catch (error) {
      noop();
    }
  }

  function getPersistedUtmValues() {
    /** @type {Record<string, string>} */
    var result = {};
    for (var i = 0; i < UTM_PARAMS.length; i++) {
      var key = UTM_PARAMS[i] || "";
      if (!key) continue;
      // Prefer last-touch UTMs; fall back to first-touch if last doesn't exist.
      var lastValue = (getStoredValue("last_" + key) || "").trim();
      var firstValue = (getStoredValue("first_" + key) || "").trim();
      var value = lastValue || firstValue;
      if (!shouldPersistUtmParam(key, value)) continue;
      if (value) result[key] = value;
    }
    return result;
  }

  /** @param {string} pathname */
  function shouldDecoratePathname(pathname) {
    try {
      if (!pathname) return false;
      // Avoid touching Shopify checkout URLs (often different domain/flow).
      if (pathname.indexOf("/checkout") === 0) return false;
      return true;
    } catch (error) {
      return false;
    }
  }

  /** @param {string} rawUrl */
  function decorateUrlWithUtms(rawUrl) {
    try {
      if (!isUtmUrlPersistenceAllowed()) return rawUrl;
      if (!rawUrl || typeof rawUrl !== "string") return rawUrl;

      var trimmed = rawUrl.trim();
      if (!trimmed) return rawUrl;
      if (trimmed.indexOf("#") === 0) return rawUrl;
      if (/^(mailto:|tel:|sms:|javascript:)/i.test(trimmed)) return rawUrl;

      var base = window.location.href;
      var url = new URL(trimmed, base);
      if (url.origin !== window.location.origin) return rawUrl;
      if (!shouldDecoratePathname(url.pathname)) return rawUrl;

      var persisted = getPersistedUtmValues();
      var hasPersistedAny = false;
      for (var k in persisted) {
        if (Object.prototype.hasOwnProperty.call(persisted, k)) {
          hasPersistedAny = true;
          break;
        }
      }
      if (!hasPersistedAny) return rawUrl;

      for (var i = 0; i < UTM_PARAMS.length; i++) {
        var utmKey = UTM_PARAMS[i] || "";
        if (!utmKey) continue;
        var utmValue = persisted[utmKey];
        if (typeof utmValue !== "string" || !utmValue) continue;
        url.searchParams.set(utmKey, utmValue);
      }

      // Keep relative URLs relative when possible.
      var isAbsolute = /^(https?:)?\/\//i.test(trimmed);
      if (!isAbsolute && trimmed.indexOf("/") !== 0) {
        return url.href;
      }
      return url.pathname + (url.search || "") + (url.hash || "");
    } catch (error) {
      return rawUrl;
    }
  }

  function ensureCurrentUrlHasUtms() {
    try {
      if (!isUtmUrlPersistenceAllowed()) return;

      var persisted = getPersistedUtmValues();
      var hasPersistedAny = false;
      for (var k in persisted) {
        if (Object.prototype.hasOwnProperty.call(persisted, k)) {
          hasPersistedAny = true;
          break;
        }
      }
      if (!hasPersistedAny) return;
      if (!shouldDecoratePathname(window.location.pathname)) return;

      var current = new URL(window.location.href);
      var changed = false;
      for (var i = 0; i < UTM_PARAMS.length; i++) {
        var utmKey = UTM_PARAMS[i] || "";
        if (!utmKey) continue;
        var utmValue = persisted[utmKey];
        if (typeof utmValue !== "string" || !utmValue) continue;
        var existing = (current.searchParams.get(utmKey) || "").trim();
        if (existing !== utmValue) {
          current.searchParams.set(utmKey, utmValue);
          changed = true;
        }
      }
      if (!changed) return;

      // Replace without reloading, keeping scroll/state.
      window.history.replaceState(window.history.state, document.title, current.pathname + current.search + current.hash);
    } catch (error) {
      noop();
    }
  }

  function decorateExistingLinks() {
    try {
      if (!isUtmUrlPersistenceAllowed()) return;

      var anchors = document.querySelectorAll("a[href]");
      for (var i = 0; i < anchors.length; i++) {
        var a = anchors[i];
        if (!a) continue;
        var href = a.getAttribute("href") || "";
        var nextHref = decorateUrlWithUtms(href);
        if (nextHref && nextHref !== href) a.setAttribute("href", nextHref);
      }
    } catch (error) {
      noop();
    }
  }

  function installNavigationPersistenceHooks() {
    try {
      if (!isUtmUrlPersistenceAllowed()) return;

      // Handle SPA-ish navigations.
      var originalPushState = window.history.pushState;
      var originalReplaceState = window.history.replaceState;

      window.history.pushState = function () {
        var result = originalPushState.apply(window.history, arguments);
        ensureCurrentUrlHasUtms();
        return result;
      };

      window.history.replaceState = function () {
        var result = originalReplaceState.apply(window.history, arguments);
        ensureCurrentUrlHasUtms();
        return result;
      };

      window.addEventListener("popstate", function () {
        ensureCurrentUrlHasUtms();
      });

      // Event delegation: decorate just-in-time before navigation.
      document.addEventListener(
        "click",
        function (event) {
          try {
            var target = /** @type {any} */ (event.target);
            if (!target || !target.closest) return;
            var link = target.closest("a[href]");
            if (!link) return;
            var href = link.getAttribute("href") || "";
            var nextHref = decorateUrlWithUtms(href);
            if (nextHref && nextHref !== href) link.setAttribute("href", nextHref);
          } catch (e) {
            noop();
          }
        },
        true
      );
    } catch (error) {
      noop();
    }
  }

  function getUTMs() {
    /** @type {Record<string, string>} */
    var data = {};
    var i;

    for (i = 0; i < UTM_PARAMS.length; i++) {
      var utmParam = UTM_PARAMS[i] || "";
      if (!utmParam) continue;
      var firstValue = getStoredValue("first_" + utmParam) || "";
      var lastValue = getStoredValue("last_" + utmParam) || "";
      if (utmParam === "utm_content") {
        if (isModalStepUtmContent(firstValue)) firstValue = "";
        if (isModalStepUtmContent(lastValue)) lastValue = "";
      }
      data["first_" + utmParam] = firstValue;
      data["last_" + utmParam] = lastValue;
    }

    for (i = 0; i < EXTRA_KEYS.length; i++) {
      var extraKey = EXTRA_KEYS[i] || "";
      if (!extraKey) continue;
      data[extraKey] = getStoredValue(extraKey) || "";
    }

    return data;
  }

  function pushUTMDataLayerEvent() {
    try {
      var data = getUTMs();
      var payload = /** @type {any} */ ({
        event: "utm_data",
        utm_data: {}
      });
      var globalWindow = /** @type {any} */ (window);
      var hasAnyValue = false;

      for (var key in data) {
        if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
        var value = data[key] || "";
        payload.utm_data[key] = value;
        payload[key] = value;

        if (typeof value === "string" && value.trim() !== "") {
          hasAnyValue = true;
        }
      }

      if (!hasAnyValue) return;

      if (!Array.isArray(globalWindow.dataLayer)) {
        globalWindow.dataLayer = [];
      }

      globalWindow.dataLayer.push(payload);
    } catch (error) {
      noop();
    }
  }

  function isGTMReady() {
    try {
      var globalWindow = /** @type {any} */ (window);
      return !!(globalWindow && globalWindow.google_tag_manager);
    } catch (error) {
      return false;
    }
  }

  function scheduleUTMDataLayerRetryOnLoad() {
    try {
      if (!shouldRetryUTMDataLayerOnLoad) return;

      window.addEventListener(
        "load",
        function () {
          pushUTMDataLayerEvent();
          shouldRetryUTMDataLayerOnLoad = false;
        },
        { once: true }
      );
    } catch (error) {
      noop();
    }
  }

  function buildCartAttributes() {
    var data = getUTMs();
    /** @type {Record<string, string>} */
    var attributes = {};

    for (var key in data) {
      if (!Object.prototype.hasOwnProperty.call(data, key)) continue;
      var value = data[key];
      if (typeof value === "string" && value.trim() !== "") {
        attributes[key] = value.trim();
      }
    }

    if (didResetLastTouchForDirectEntry) {
      for (var i = 0; i < UTM_PARAMS.length; i++) {
        var utmParam = UTM_PARAMS[i] || "";
        if (!utmParam) continue;
        attributes["last_" + utmParam] = "";
      }
    }

    return attributes;
  }

  /** @param {Record<string, string>} obj */
  function buildStableSignature(obj) {
    /** @type {Record<string, string>} */
    var ordered = {};
    var keys = Object.keys(obj).sort();

    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (typeof k !== "string" || !k) continue;
      var v = obj[k];
      if (typeof v !== "string") continue;
      ordered[k] = v;
    }

    try {
      return JSON.stringify(ordered);
    } catch (error) {
      return "";
    }
  }

  /** @param {Record<string, string>} attributes @param {string} signature */
  function postCartAttributes(attributes, signature) {
    try {
      if (!window.fetch) return;

      window
        .fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({ attributes: attributes })
        })
        .then(function (response) {
          if (response && response.ok) {
            setStoredValue(STORAGE_KEY_LAST_SIGNATURE, signature);
            queuedSignature = "";
          }
        })
        .catch(noop);
    } catch (error) {
      noop();
    }
  }

  function syncCartAttributes() {
    try {
      var attributes = buildCartAttributes();
      if (Object.keys(attributes).length === 0) return;

      var nextSignature = buildStableSignature(attributes);
      if (!nextSignature) return;

      var lastSentSignature = getStoredValue(STORAGE_KEY_LAST_SIGNATURE) || "";
      if (nextSignature === lastSentSignature || nextSignature === queuedSignature) return;

      queuedSignature = nextSignature;

      if (syncTimer) {
        clearTimeout(syncTimer);
      }

      // Debounce cart updates to avoid repeated API calls during rapid navigation/events.
      syncTimer = setTimeout(function () {
        postCartAttributes(attributes, nextSignature);
      }, DEBOUNCE_MS);
    } catch (error) {
      noop();
    }
  }

  function init() {
    prepareSessionAttribution();
    captureTrackingData();
    ensureCurrentUrlHasUtms();
    installNavigationPersistenceHooks();
    pushUTMDataLayerEvent();
    shouldRetryUTMDataLayerOnLoad = !isGTMReady();
    scheduleUTMDataLayerRetryOnLoad();
    /** @type {any} */ (window).getUTMs = getUTMs;

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        function () {
          decorateExistingLinks();
        },
        { once: true }
      );
    } else {
      decorateExistingLinks();
    }

    // Run after critical rendering work whenever possible.
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(syncCartAttributes, { timeout: 1500 });
    } else {
      setTimeout(syncCartAttributes, 0);
    }
  }

  try {
    init();
  } catch (error) {
    noop();
  }
})();
